import { __rest } from './../external/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import '@apollo/client';
import '../utils/popupUtils.js';
import { makeStyles } from '../utils/stylesUtils.js';
/** A Material UI button with extended features. */

var ExtendedButton = function ExtendedButton(_a) {
  var hidden = _a.hidden,
      children = _a.children,
      _a$loaderSize = _a.loaderSize,
      loaderSize = _a$loaderSize === void 0 ? 25 : _a$loaderSize,
      loading = _a.loading,
      className = _a.className,
      backgroundColor = _a.backgroundColor,
      props = __rest(_a, ["hidden", "children", "loaderSize", "loading", "className", "backgroundColor"]);

  var _useStyles = useStyles({
    loading: loading,
    backgroundColor: backgroundColor
  }),
      classes = _useStyles.classes,
      cx = _useStyles.cx;

  var buttonProps = !loading ? props : Object.assign(Object.assign({}, props), {
    startIcon: null,
    endIcon: null
  });
  return hidden ? null : jsxs(Button, Object.assign({
    disabled: loading,
    className: cx(className, classes.button)
  }, buttonProps, {
    children: [loading && jsx(CircularProgress, {
      size: loaderSize,
      className: classes.spinner
    }), jsx("div", Object.assign({
      className: classes.contentWrapper
    }, {
      children: children
    }))]
  }));
};

var customButtonColor = function customButtonColor(theme, backgroundColor) {
  var _theme$palette$augmen = theme.palette.augmentColor({
    color: {
      main: backgroundColor
    }
  }),
      dark = _theme$palette$augmen.dark;

  return {
    backgroundColor: backgroundColor,
    color: theme.palette.getContrastText(backgroundColor),
    "&:hover": {
      backgroundColor: dark
    }
  };
};

var useStyles = makeStyles()(function (theme, _ref) {
  var backgroundColor = _ref.backgroundColor,
      loading = _ref.loading;
  return {
    button: Object.assign(Object.assign({}, backgroundColor && customButtonColor(theme, backgroundColor)), loading && {
      justifyContent: "center"
    }),
    contentWrapper: {
      opacity: loading ? 0 : 1
    },
    spinner: Object.assign({
      position: "absolute"
    }, backgroundColor && {
      color: backgroundColor
    })
  };
});
export { ExtendedButton };